import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { DialogBeneficiaryZelleComponent } from '../../dialog-beneficiary-zelle/dialog-beneficiary-zelle.component';
import { RecipientZelleService } from 'src/app/dashboard/services/recipient-zelle.service';
import { BeneficiarioZelle } from 'src/app/dashboard/interfaces/beneficiario-zelle.interface';

@Component({
  selector: 'app-recipient-zelle-card',
  templateUrl: './recipient-zelle-card.component.html',
  styleUrls: ['./recipient-zelle-card.component.sass']
})
export class RecipientZelleCardComponent implements OnInit {
  @Input() cuenta: BeneficiarioZelle | undefined;
  @Input() isExpanded: boolean = false;
  @Output() deleteAccount: EventEmitter<any> = new EventEmitter();
  @Output() actualizarCuenta: EventEmitter<BeneficiarioZelle> = new EventEmitter();
  subscriptions: Subscription = new Subscription();
  public user: any;

  constructor(
    private accountRecipientService: RecipientZelleService,
    private spinner: SpinnerService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private store: Store<AppState>) { }

  ngOnInit() {
    this.subscriptions.add(
      this.store.select('auth').subscribe(({ user }: any) => {
        this.user = user;
      })
    );
  }


  async verCuenta(){
    const isMobile = window.innerWidth < 768;
    this.dialog.open(DialogBeneficiaryZelleComponent, {
      data: this.cuenta,
      disableClose: true,
      panelClass: 'aguacate-dialog',
      maxWidth: isMobile ? '95vw' : '500px',
      minWidth: isMobile ? '90vw' : '420px',
      maxHeight: '90vh',
    });
  }


  async inactivarCuenta(){
    if( !(this.cuenta && this.cuenta.id))return;
    const resullt = await Swal.fire({
      title: '¿Está seguro de que desea desvincular esta cuenta?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: `No`,
      confirmButtonColor: '#1e5a3f',
    });
    if(resullt.isDenied || !resullt.isConfirmed){
      return;
    }
    const spinnerRef  = this.spinner.start();
    try {
      await this.accountRecipientService.inactivateAccount(this.cuenta.id);
      this.snackBar.open('Cuenta eliminada correctamente', 'Ok', {
        duration: 3000
      });
      this.deleteAccount.emit();
    } catch (error) {
    }
    this.spinner.stop(spinnerRef);

  }

  actualizar(){
    this.actualizarCuenta.emit(this.cuenta);
  }
}
